import { Component } from "@theme/component";

/**
 *
 * @template {import('@theme/component').Refs} [Refs = {}]
 *
 * @extends Component<Refs>
 */

if (!customElements.get("rug-quiz")) {
    class RugQuiz extends Component {
        connectedCallback() {
            this.filterText = "";
            this.currentStep = parseInt(this.getAttribute("current-step"), 10);
            this.addEventListener("change", this.handleSelect.bind(this));
            this.nextButtons.forEach((button) => {
                button.addEventListener("click", this.handleNext.bind(this));
            });
            this.skipButtons.forEach((button) => {
                button.addEventListener("click", this.handleSkip.bind(this));
            });
            this.backButton.addEventListener(
                "click",
                this.handleBack.bind(this),
            );
            window.dataLayer.push({
                event: "rug_finder_start",
            });

            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "current-step") {
                        const currentStep = parseInt(
                            this.getAttribute("current-step"),
                            10,
                        );
                        const willShowElement =
                            this.blockWrapper?.children[currentStep];
                        for (const child of this.blockWrapper.children) {
                            child.style.display = "none";
                        }

                        willShowElement.style.display = "block";
                        this.stepInfo.innerHTML = currentStep + 1;
                        const skipButton =
                            willShowElement.querySelector(".skip-button");
                        const nextButton =
                            willShowElement.querySelector(".next-button");
                        if (
                            currentStep + 1 ===
                            this.blockWrapper?.children?.length
                        ) {
                            skipButton.style.display = "none";
                            nextButton.style.display = "inline-block";
                            nextButton.innerHTML = "Show Matching Rugs";
                        } else {
                            skipButton.style.display = "inline-block";
                        }
                        if (currentStep < 1) {
                            this.backButton.style.display = "none";
                        }
                    }
                });
            });

            observer.observe(this, { attributes: true });
        }

        handleSelect(e) {
            if (!(e.target instanceof HTMLElement)) return;
            const currentElement = this.blockWrapper.children[this.currentStep];
            let newQueryText = currentElement.getAttribute("query-text") ?? "";
            const inputLi = e.target.closest("li");
            if (!inputLi) return;
            const input = inputLi.querySelector("input[type='checkbox']");
            if (!input) return;
            const isMulti = currentElement.getAttribute("is-multi") === "true";
            const filterValue = input.value || "";
            const nextButton = currentElement.querySelector(".next-button");

            if (isMulti) {
                const cardMedia = inputLi?.querySelector(".card__media");
                if (!cardMedia) return;
                cardMedia.classList.toggle("active");
                if (cardMedia.classList.contains("active")) {
                    this.filterText += filterValue;
                    newQueryText += filterValue;
                } else {
                    this.filterText = this.filterText.replace(filterValue, "");
                    newQueryText = newQueryText.replace(filterValue, "");
                }

                if (newQueryText?.length > 0) {
                    nextButton.style.display = "inline-block";
                } else {
                    if (
                        this.currentStep + 1 <
                        this.blockWrapper?.children?.length
                    )
                        nextButton.style.display = "none";
                }
                currentElement.setAttribute("query-text", newQueryText);
            } else {
                //this.currentStep += 1;
                this.handleNext();
                //this.setAttribute("current-step", this.currentStep);
                this.filterText += filterValue;
            }

            console.log("filterText:::", this.filterText);
        }

        handleBack() {
            if (this.currentStep < 1) return;
            this.currentStep -= 1;
            this.setAttribute("current-step", this.currentStep);
        }

        handleNext() {
            if (this.currentStep + 1 === this.blockWrapper?.children?.length) {
                const textToArray = this.filterText.split("&");
                const uniqeArray = [...new Set(textToArray)];
                const newFilterText = uniqeArray.join("&");

                window.location.href =
                    "https://boutiquerugs.com/collections/area-rugs?" +
                    newFilterText;
                window.dataLayer.push({
                    event: "rug_finder_results",
                });
                return;
            }
            this.currentStep += 1;
            this.setAttribute("current-step", this.currentStep);
            if (this.currentStep < 1) {
                this.backButton.style.display = "none";
            } else {
                this.backButton.style.display = "block";
            }
        }

        handleSkip() {
            this.currentStep += 1;
            this.setAttribute("current-step", this.currentStep);
        }

        get blockWrapper() {
            return this.querySelector(".blocks__wrapper");
        }

        get questionGroup() {
            return this.querySelector(".blocks__wrapper")?.children;
        }

        get backButton() {
            return this.querySelector('button[name="back-step"]');
        }

        get stepInfo() {
            return this.querySelector("#step-info span");
        }

        get nextButtons() {
            return this.querySelectorAll(".next-button");
        }

        get skipButtons() {
            return this.querySelectorAll(".skip-button");
        }
    }
    customElements.define("rug-quiz", RugQuiz);
}
